import {PortModelAlignment} from '@projectstorm/react-diagrams'
import {store} from '../../../../store'
import {setInitialNodeRequiresInterventionData} from '../../../../store/slices'
import {NodeTypeEnum} from '../../../../types/NodeTypeEnum'
import {removeNodeAndConnectItsParentAndTarget} from '../../utils/NodeEventUtils'
import {CustomNodeModel} from '../CustomNodeModel'
import {RequiresInterventionPortModel} from './RequiresInterventionPortModel'

// this can be further extended for more complicated node types
export class RequiresInterventionNodeModel extends CustomNodeModel {
  constructor(id?: string) {
    const obj = {
      type: NodeTypeEnum.requiresIntervention,
      id,
      extras: {
        name: 'Requires Intervention',
        priority: 4,
        nodeSize: 250,
      },
    }
    if (!id) delete obj.id

    super(obj)

    this.addPort(new RequiresInterventionPortModel(PortModelAlignment.TOP))
    this.addPort(new RequiresInterventionPortModel(PortModelAlignment.BOTTOM))

    store.dispatch(
      setInitialNodeRequiresInterventionData({
        id: this.getID(),
        type: NodeTypeEnum.requiresIntervention,
      })
    )
  }

  remove() {
    removeNodeAndConnectItsParentAndTarget(this.getID(), () => super.remove())
  }
}
